import React, {useEffect, useRef, useState} from 'react';
import utils from "../../lib/utils";
import Box from "../../Common/Box";
import {Message} from "../../lib/stores/MessageStore";
import {alpha, useTheme} from "@mui/material/styles";
import config from "../../config";
import {parseContent} from "./parseContent";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import Controls from "./Controls";
import {renderToString} from "react-dom/server";
import {setCursorToEnd} from "../utils";
import BasicInput from "../BasicInput";
import uiStore from "../../lib/stores/uiStore";
import {APIAttachment} from "discord-api-types/v10";
import {Emoji} from "../Emoji";
import {notifier} from "../../lib/Notifier";
import {action} from "mobx";

const ContentMessage = (
        {
            message
        }: { message: Message }) => {
    const {
        author,
        content,
        attachments,
        reactions,
    } = message;

    const theme = useTheme();
    const avatar_url = utils.createAvatarUrl(author['avatar'], 30)
    const [avatarUrl, setAvatarUrl] = useState(avatar_url);
    const imgRef = useRef<HTMLImageElement>(null);
    const avatarRef = useRef();
    const usernameRef = useRef();

    const margin = 30;
    const scrollbar = 15;
    const totalMargin = uiStore.isMobile ? margin : margin + scrollbar;
    const messageWidth = uiStore.messagesWidth - totalMargin;

    //@todo make use of a proper store (which includes fetch?)
    const users = shadowClient.userStore.users;
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [editing, setEditing] = useState(false);
    const inputRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (inputRef.current && editing) {
            inputRef.current.innerHTML = renderToString(parseContent(content, users));
            setCursorToEnd(inputRef.current);
        }

    }, [inputRef.current, editing]);

    // useEffect(() => {
    //     if(usernameRef.current && author.id === "7211019267666345984"){
    //         usernameRef.current.click();
    //     }
    // }, [usernameRef.current]);

    function openImage(item: APIAttachment) {
        window.open(config.apiUrl + '/static/images/' + item.filename, '_blank');
    }

    return <Box
            column
            sx={{
                border: "1px solid",
                borderColor: theme.palette.background.paper,
                borderRadius: "4px",
                margin: "15px",
                wordBreak: "break-all",
            }}
    >
        <div style={{
            display: "flex",
            // alignItems: "center",
            padding: "10px",
            position: "relative",
            background: overlayVisible ? alpha(theme.palette.background.paper, 0.3) : "",
        }}
             onClick={() => {
                 if (uiStore.isMobile) {
                     setOverlayVisible(!overlayVisible);
                 }
             }}
             onMouseOver={() => {
                 if (!uiStore.isMobile) {
                     setOverlayVisible(true);
                 }
             }}
             onMouseLeave={() => {
                 if (!uiStore.isMobile) {
                     setOverlayVisible(false);
                 }
             }}
        >
            <Controls
                    visible={overlayVisible}
                    message={message}
                    onEditPressed={() => setEditing(true)}
            />
            <img
                    ref={avatarRef}
                    onClick={action(function (event) {
                        event.stopPropagation();

                        uiStore.userInfoView = {
                            userInfoPlacement: "right-start",
                            selectedUser: author,
                            userAnchorEl: avatarRef,
                        }

                        uiStore.userInfoVisible = true;
                    })}
                    crossOrigin="anonymous"
                    style={{
                        cursor: "pointer",
                        minWidth: "30px",
                        minHeight: "30px",
                        width: "30px",
                        height: "30px",
                        borderRadius: "15px",
                        marginRight: "10px",
                    }}
                    src={avatar_url || avatarUrl}
                    alt={''}
                    onError={() => {
                        if (!avatarUrl) {
                            setAvatarUrl(utils.createAvatarUrl())
                        }

                    }}
            />
            <Box flex={1} flexDirection={"column"}>
                <Box
                        ref={usernameRef}
                        sx={{
                            display: "inline",
                            cursor: "pointer",
                            fontWeight: "500",
                        }}
                        onClick={action(function (event) {
                            event.stopPropagation();

                            uiStore.userInfoView = {
                                userInfoPlacement: "right-start",
                                selectedUser: author,
                                userAnchorEl: usernameRef,
                            }

                            uiStore.userInfoVisible = true;

                        })}
                >
                    {/*@todo: this might cause problems if author doesnt exist*/}
                    {author?.username}
                </Box>
                {content && <Box
                        style={{
                            wordBreak: "break-word",
                            alignItems: "center",
                        }}
                        paddingTop={"5px"}
                >
                    {editing ?
                            <BasicInput
                                    style={{
                                        flex: 1,
                                        background: alpha(theme.palette.background.paper, 0.5),
                                        padding: "4px",
                                        borderRadius: "4px",
                                        outline: "none",
                                    }}
                                    onEscape={() => setEditing(false)}
                                    onSend={async (messageContent: string) => {
                                        try {
                                            await shadowClient.editMessage({
                                                content: messageContent
                                            }, message.room_id, message.id);
                                        } catch (e: any) {
                                            notifier.error("Failed to edit message. Error: " + e.message);
                                        }
                                        setEditing(false);
                                    }}
                                    inputRef={inputRef}/>
                            : parseContent(content, users)}

                </Box>}
            </Box>
        </div>

        {
            (attachments || []).map((attachment, i) => {
                let src;

                if (attachment.content_type && ['image/png', 'image/jpeg', 'image/gif'].includes(attachment.content_type)) {
                    if (attachment.content_type === "image/png") {
                        src = config.apiUrl + "/static/images/400w/" + attachment.id + ".jpg";
                    } else {
                        src = config.apiUrl + "/static/images/" + attachment.filename;
                    }

                } else {
                    src = config.apiUrl + "/static/items/" + attachment.filename
                }

                const width = messageWidth + "px";
                const height = messageWidth / attachment.width * attachment.height + "px";

                const style: { width: string, height?: string, } = {
                    width,
                    height
                };

                switch (attachment.content_type) {
                    case "image/gif":
                    case "image/webp":
                    case "image/bmp":
                    case "image/jpeg":
                    case "image/png":
                    case "image/svg":
                    case "image/apng":
                        return <img
                                key={i}
                                ref={imgRef}
                                src={src}
                                style={style}
                                alt={attachment.filename}
                                onClick={() => openImage(attachment)}
                        />
                    case "video/mp4":
                        return <video key={i} src={src} style={style}/>
                    case "video/webm":
                        return <video key={i} src={src} style={style}/>
                    case "audio/mpeg":
                    case "audio/mp3":
                        return <audio key={i} controls src={src} style={style}/>
                    default:
                        return null;
                }
            })}
        {reactions?.length > 0 && <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "4px",
                    flexWrap: "wrap",
                    gap: "4px",
                    // rowGap: "3px",
                }}
        >
            {reactions.map(reaction => {
                const {userIds, emoji} = reaction;
                const value = emoji.value;
                const count = userIds.length;

                // const emojiUi;
                // if (!value.startsWith("<")) {
                //     emojiUi = value;
                // } else {
                //     const parts = value.slice(1).split(":");
                //     const imgName = parts.length === 3 ? `${parts[1]}.gif` : `${parts[0]}.png`;
                //     emojiUi = <img
                //             key={reaction.emoji.value}
                //             style={{width: "18px", height: "18px"}}
                //             src={"/images/" + imgName}
                //             alt={"emoji-" + imgName}
                //     />
                // }


                return <div
                        key={reaction.emoji.value}
                        style={{
                            maxHeight: "23px",
                            display: "flex",
                            alignItems: "center",
                            background: alpha(theme.palette.background.paper, 0.5),
                            padding: "1px",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                        onClick={async () => {
                            try {
                                if (reaction.userIds.includes(shadowClient.userId)) {
                                    await shadowClient.deleteReaction(message.room_id, message.id, value);
                                } else {
                                    await shadowClient.addReaction(message.room_id, message.id, value);
                                }

                            } catch (e) {
                                notifier.error("Failed to add reaction. Error: " + e.message);
                            }
                        }}
                >
                    <Emoji emojiStr={reaction.emoji.value}/>
                    {<div style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        marginLeft: "4px",
                        marginRight: "4px",
                    }}>{count}</div>}
                </div>
            })}
        </div>}
    </Box>
};

export default ContentMessage;
